<div mat-dialog-title class="title">
    <mat-icon>edit</mat-icon>&nbsp;{{ 'DocumentRename' | translate }}
</div>
<mat-dialog-content>
    <div class="line">
        <mat-form-field>
            <mat-label>{{ 'file_name' | translate }}</mat-label>
            <input matInput [formControl]="form" />
            <mat-hint align="end">{{ form.value.length }} / {{ NAME_MAX_LENGTH }}</mat-hint>
            <mat-error *ngIf="form.errors && form.errors['required']">{{ 'Field_required' | translate }}</mat-error>
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>{{ 'Cancel' | translate }}</button>
    <button mat-raised-button (click)="onConfirmClicked()" color="accent">{{ 'Confirm' | translate }}</button>
</mat-dialog-actions>
